import React, { useState, useEffect } from 'react';
import { Modal, ModalBody, ModalFooter, Button } from 'reactstrap';
import Select from 'react-select';
import Draggable from 'react-draggable';
const customStyles = {
  control: (provided) => ({
    ...provided,
    marginBottom: '20px'
  })
};
const CustomerGrowthModal = ({ isOpen, toggle }) => {
  const activeOptions = [
    { value: 'active', label: 'Active' },
    { value: 'inactive', label: 'Inactive' }
  ];
  const [hasClickedContinue, setHasClickedContinue] = useState(false);
  const handleContinue = () => {  
    console.log('Continue button clicked');
  };
  const productOptions = [
    { value: 'rolex', label: 'Rolex' },          // Saat
    { value: 'louisvuitton', label: 'Louis Vuitton' }, // Moda ve Aksesuar
    { value: 'gucci', label: 'Gucci' },          // Moda ve Aksesuar
    { value: 'chanel', label: 'Chanel' },        // Moda ve Aksesuar
    { value: 'hermes', label: 'Hermès' },        // Moda ve Aksesuar
    { value: 'ferrari', label: 'Ferrari' },      // Otomobil
    { value: 'bentley', label: 'Bentley' },      // Otomobil
    { value: 'prada', label: 'Prada' },          // Moda ve Aksesuar
    { value: 'tiffany', label: 'Tiffany & Co.' },// Mücevherat
    { value: 'cartier', label: 'Cartier' },      // Mücevherat
];
  const [selectedActive, setSelectedActive] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState([]);
  const [matchUser, setMatchUser] = useState(1281023);
  useEffect(() => {
    let totalMatch = 0;
    if (selectedActive.some(opt => opt.value === 'active')) totalMatch += 838293;
    if (selectedActive.some(opt => opt.value === 'inactive')) totalMatch += 442730;
    if (selectedProduct && selectedProduct.length) {
      const reductionFactor = selectedProduct.length * 0.13;
      totalMatch = totalMatch * (1 - reductionFactor);
    }
    setMatchUser(Math.round(Math.max(totalMatch, 0)));
  }, [selectedActive, selectedProduct]);
  return (
    <Draggable handle=".modal-header">
    <Modal isOpen={isOpen} toggle={toggle} centered={true}>
      {hasClickedContinue ? (
        <>
          <StepProgress />
        <div style={{ padding: '20px' }}>Your desired text here.</div>
        </>
      ) : (
        <>
          <ModalBody>
            <Select
              options={activeOptions}
              isMulti={true}
              placeholder="Active/Inactive"
              onChange={setSelectedActive}
            />
            <Select
              options={productOptions}
              isMulti={true}
              placeholder="Product"
              onChange={setSelectedProduct}
            />
          </ModalBody>
          <ModalFooter>
            <p style={{ marginRight: 'auto' }}>Match User: {matchUser}</p> 
            <Button color="primary" onClick={handleContinue}>Continue</Button>
          </ModalFooter>
        </>
      )}
    </Modal>
        </Draggable>
  );
};
export default CustomerGrowthModal;